import { render, staticRenderFns } from "./HostingBenefits.vue?vue&type=template&id=161db65a&"
import script from "./HostingBenefits.vue?vue&type=script&lang=js&"
export * from "./HostingBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports